import gql from "graphql-tag";

export const GET_BEST_TIME_SLICE_WEB_MERCATOR_PNGS = gql`
  query GET_BEST_TIME_SLICE_WEB_MERCATOR_PNGS(
    $input: BestTimeSlicePngRequestInput!
  ) {
    png: bestTimeSlicePNG(input: $input) {
      dataSource {
        id
        name
      }
      data
      geojsonEnvelope
      instant
      leadTime
      srid
      variable {
        id
      }
    }
  }
`;
